import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './AiAgentInput.css';
import AiAgentFileIcon from '../../../../assets/icons/AiAgentFileIcon';
import XIcon from '../../../../assets/icons/XIcon';

interface AiAgentAttachmentPreviewProps {
    previewUrl: string | null;
    fileName: string | null;
    onRemove: () => void;
}

function AiAgentAttachmentPreview({previewUrl, fileName, onRemove}: AiAgentAttachmentPreviewProps) {
    const {t} = useTranslation('aiAgent');

    if(!previewUrl && !fileName) {
        return null;
    }

    const removeButton = (
        <css.removeAttachmentButton
            type="button"
            onClick={onRemove}
            aria-label={t('removeAttachment')}
            data-cy="ai-agent-remove-attachment"
        >
            <XIcon color="white" width={12} height={12} />
        </css.removeAttachmentButton>
    );

    return (
        <css.attachmentRow>
            {previewUrl ? (
                <css.attachmentPreview>
                    <css.attachmentImage src={previewUrl} alt="" />
                    {removeButton}
                </css.attachmentPreview>
            ) : (
                <css.fileAttachmentPreview>
                    <css.fileAttachmentName>{fileName}</css.fileAttachmentName>
                    <AiAgentFileIcon />
                    {removeButton}
                </css.fileAttachmentPreview>
            )}
        </css.attachmentRow>
    );
}

export default AiAgentAttachmentPreview;
